import React, { useMemo, useState, useEffect } from "react";
import {
    Accordion,
    Icon,
    Feed,
    Button,
    Message,
    Segment,
    Header,
    Loader,
} from "semantic-ui-react";

const WarehousePaxelAccordion = ({ idOrder }) => {
    const [activeWarehouses, setActiveWarehouses] = useState([]);
    const [paxelLogs, setPaxelLogs] = useState({});
    const [warehouseMaster, setWarehouseMaster] = useState({});
    const [loadingLogs, setLoadingLogs] = useState(false);
    const [loadingWarehouse, setLoadingWarehouse] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!idOrder) return;

        const fetchLogs = async () => {
            try {
                setLoadingLogs(true);

                const response = await fetch(
                    `${global.SRV}api_hoops_cms/controler/courier.php/?index=8&id_order=${idOrder}`
                );

                const result = await response.json();

                if (result.state !== 200) throw new Error(result.message);

                const grouped = result.data.reduce((acc, log) => {
                    const key = log.id_warehouse;

                    if (!acc[key]) acc[key] = [];

                    acc[key].push(log);

                    return acc;
                }, {});

                setPaxelLogs(grouped);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoadingLogs(false);
            }
        };

        fetchLogs();
    }, [idOrder]);

    useEffect(() => {
        const fetchWarehouse = async () => {
            try {
                setLoadingWarehouse(true);

                const response = await fetch(
                    `${global.hoops_api}api_hoops/controler/cart.php/?index=22`
                );

                const result = await response.json();

                if (result.state !== 200) throw new Error(result.message);
                setWarehouseMaster(result.data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoadingWarehouse(false);
            }
        };

        fetchWarehouse();
    }, []);

    useState(() => {
        console.log(warehouseMaster)
    }, [warehouseMaster]);


    const warehouseIds = useMemo(() => {
        const ids = Object.keys(paxelLogs);

        return ids.sort((a, b) => {
            if (a === "WH0006") return -1;

            if (b === "WH0006") return 1;

            return a.localeCompare(b);
        });
    }, [paxelLogs]);


    useEffect(() => {
        if (warehouseIds.includes("WH0006")) {
            setActiveWarehouses(["WH0006"]);
        }
    }, [warehouseIds]);

    const toggleAccordion = (warehouseId) => {
        setActiveWarehouses((prev) =>
            prev.includes(warehouseId)
                ? prev.filter((id) => id !== warehouseId)
                : [...prev, warehouseId]
        );
    };

    const openImage = (url) => {
        if (!url) return;
        window.open(url, "_blank", "noopener,noreferrer");
    };


    if (loadingLogs || loadingWarehouse) {
        return <Segment
            basic
            style={{
                minHeight: 50,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}
        >
            <Loader active />
        </Segment>
    }

    if (error) {
        return <Message negative content={error} />;
    }

    if (!warehouseIds.length) {
        return (
            <Message info content="Tracking information is not available yet." />
        );
    }

    return (
        <Accordion fluid>
            {warehouseIds.map((warehouseId) => {
                const logs = paxelLogs[warehouseId];

                const sortedLogs = [...logs].sort(
                    (a, b) =>
                        new Date(b.delivery_datetime) - new Date(a.delivery_datetime)
                );

                const warehouse = warehouseMaster[warehouseId];
                const currentResi = sortedLogs.length > 0 ? sortedLogs[0].no_resi : "-";

                return (
                    <React.Fragment key={warehouseId}>
                        <Accordion.Title
                            active={activeWarehouses.includes(warehouseId)}
                            onClick={() => toggleAccordion(warehouseId)}
                        >
                            <h4>
                                <Icon
                                    name={
                                        activeWarehouses.includes(warehouseId)
                                            ? "angle down"
                                            : "angle right"
                                    }
                                    color="orange"
                                />
                                {warehouse?.name ?? "Unknown Warehouse"}
                                {" (Nomor Resi: "}
                                {currentResi ?? "-"}
                                {")"}
                            </h4>
                        </Accordion.Title>
                        <Accordion.Content active={activeWarehouses.includes(warehouseId)}>
                            <Segment basic>
                                <div className="timeline-container">
                                    {sortedLogs
                                        .sort((a, b) => new Date(b.delivery_datetime) - new Date(a.delivery_datetime))
                                        .map((log, index) => {
                                            const isLatest = index === 0;
                                            const activeColor = log.color || "#27AE60";
                                            const dateString = log.delivery_datetime;

                                            const validDateString = dateString.replace(" ", "T");
                                            const date = new Date(validDateString);

                                            const options = {
                                                timeZone: 'Asia/Jakarta',
                                                year: 'numeric',
                                                month: 'long',
                                                day: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                second: '2-digit',
                                                hour12: false
                                            };

                                            const formattedDate = new Intl.DateTimeFormat('en-GB', options).format(date);

                                            return (
                                                <div key={log.id} className="timeline-item">
                                                    <div
                                                        className="timeline-line"
                                                        style={{
                                                            backgroundColor: log.color
                                                        }}
                                                    />

                                                    <div
                                                        className="timeline-dot"
                                                        style={{
                                                            backgroundColor: isLatest ? activeColor : "#fff",
                                                            boxShadow: `0 0 0 2px ${isLatest ? activeColor : "#e0e0e0"}`
                                                        }}
                                                    />

                                                    <div className="timeline-content">
                                                        <div
                                                            className="timeline-status"
                                                            style={{
                                                                color: log.color,
                                                                fontWeight: isLatest ? "bold" : "normal"
                                                            }}
                                                        >
                                                            <h4>{`${log.info?.toUpperCase()} (${log.status})`}</h4>
                                                        </div>

                                                        <div className="timeline-date" color="black">
                                                            <h6>
                                                                {
                                                                    formattedDate
                                                                }
                                                            </h6>
                                                        </div>

                                                        <div className="timeline-info">
                                                            <div className="info-grid">
                                                                {/* Driver Info */}
                                                                <div className="info-item">
                                                                    <Icon name="user circle" color="grey" />
                                                                    <span>Driver: <strong className="info-label">{log.driver_name ?? "-"}</strong></span>
                                                                </div>

                                                                <span style={{ color: '#cbd5e1' }}>•</span>

                                                                {/* Note Info */}
                                                                <div className="info-item">
                                                                    <Icon name="sticky note outline" color="grey" />
                                                                    <span>Note: <em>{log?.note ?? "-"}</em></span>
                                                                </div>
                                                            </div>

                                                            {/* Cancellation Section - Hanya muncul jika ada */}
                                                            {log.cancellation_reason && (
                                                                <div className="reason-box">
                                                                    <Icon name="warning sign" />&ensp;
                                                                    Cancellation Reason: <strong>{log.cancellation_reason}</strong>
                                                                </div>
                                                            )}

                                                            {log.image_url && (
                                                                <div className="custom-border-dashed">
                                                                    <Button
                                                                        size="tiny"
                                                                        color="blue"
                                                                        basic
                                                                        className="view-proof-btn"
                                                                        icon="images outline"
                                                                        content="Snapshot Evidence"
                                                                        onClick={() => openImage(log.image_url)}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                            </Segment>
                        </Accordion.Content>
                    </React.Fragment>
                );
            })}
        </Accordion>
    );
};

export default WarehousePaxelAccordion;